var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-btn', {
    staticClass: "white--text ml-0",
    attrs: {
      "color": "pink darken-2"
    },
    on: {
      "click": function click($event) {
        _vm.mediaDialog = true;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.uploadTakePhoto')) + "\n    "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("photo_camera")])], 1), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_vm.savedMedia && _vm.savedMedia.length > 0 ? _c('span', [_vm._v(_vm._s(_vm.savedMedia.length) + "\n      " + _vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.photosSelected')))]) : _c('span', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.atLeastOnePhoto')))])]), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.mediaDialog,
      callback: function callback($$v) {
        _vm.mediaDialog = $$v;
      },
      expression: "mediaDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.media').toUpperCase()) + "\n      ")]), _c('v-card-text', [_c('v-toolbar', {
    attrs: {
      "color": "white",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        return _vm.saveMedia();
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.uploadTakePhoto')))]), _c('v-spacer')], 1), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('camera-dialog', {
    attrs: {
      "stage": this.stage
    }
  })], 1), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "uploadButton btn-file",
    attrs: {
      "color": "blue darken-2"
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("attach_file")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("Upload Photos")]), _c('input', {
    ref: "photoFiles",
    attrs: {
      "accept": "image/*",
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": _vm.handleFiles
    }
  })], 1)], 1)], 1)], 1), _vm.uploadProgress ? _c('v-layout', {
    attrs: {
      "mb-3": "",
      "mt-1": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "height": "30",
      "color": "orange"
    },
    model: {
      value: _vm.uploadProgress,
      callback: function callback($$v) {
        _vm.uploadProgress = $$v;
      },
      expression: "uploadProgress"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.uploadProgress) + "%\n            ")])], 1)], 1) : _vm._e()], 1), _c('pre-work-analysis-media-list', {
    ref: "mediaList",
    attrs: {
      "mediaItems": _vm.getMediaList(_vm.callDetail)
    }
  }), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "row": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.saveMedia();
      }
    }
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.save')))])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }